;(function (angular, _) {
  'use strict'
  angular
    .module('kilo.common.controllers')
    .controller('SelectPreFilledTemplateController', SelectPreFilledTemplateController)

  SelectPreFilledTemplateController.$inject = [
    // Angular
    '$uibModalInstance', '$state',

    // Managers
    'InvoiceManager', 'QuoteManager',

    // Services
    'TemplateService',

    // Resolve
    'type', 'mode'

  ]

  function SelectPreFilledTemplateController (
    // Angular
    $uibModalInstance, $state,

    // Managers
    InvoiceManager, QuoteManager,

    // Services
    TemplateService,

    // Resolve
    type, mode

  ) {
    let self = this

    self.$onInit = () => {
      _.extend(self, {
        $state: $state,
        InvoiceManager: InvoiceManager,
        QuoteManager: QuoteManager,
        TemplateService: TemplateService,
        type: type,
        mode: mode,
        templates: []
      })
      init()
    }

    function searchTemplates (type) {
      let manager = type === 'invoice' ? InvoiceManager : QuoteManager
      let query = manager
        .query({
          conditions: {
            isModel: true
          }
        })
        .fields('_id modelTitle title lines discountedTotal rubrics legalNotices thanks conditions')
        .limit(100)
      if (self.templateSearch) {
        let numberSearch = self.templateSearch.replace(/,/g, '.')
        query.setQuery(
          { $or: [
            { modelTitle: { $regex: '.*' + self.templateSearch + '.*', $options: 'i' } },
            { 'discountedTotal': (numberSearch * 100) }
          ] }
        )
      }
      manager.get(query).then(function (data) {
        self.loading = false
        self.templates = data.data
      })
    }

    function selectTemplate (template) {
      var initParams = {
        title: template.title,
        lines: template.lines,
        rubrics: template.rubrics,
        legalNotices: template.legalNotices,
        thanks: template.thanks,
        conditions: template.conditions
      }
      switch (self.type) {
        case 'invoice':
          return $state.go('invoice.new', { initParams: initParams })
        case 'quote':
          return $state.go('quote.new', { initParams: initParams })
      }
    }

    function accept () {
      $uibModalInstance.close(true)
    }

    function validate (title) {
      $uibModalInstance.close(title)
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }

    function init () {
      if (self.mode === 'select') {
        searchTemplates(type)
      }
    }

    _.extend(self, {
      searchTemplates: searchTemplates,
      selectTemplate: selectTemplate,
      cancel: cancel,
      validate: validate,
      accept: accept
    })
  }
})(window.angular, window._)
